let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8d7c3")).then(() => parcelRequire('610aq'));